<template>
    <div id="app">
        <v-app>
            <component :is="currentComponent"></component>
            <v-snackbar
                v-model="requireReload"
                top
                :timeout="0"
            >
                A new version of Paper is available.
                <v-btn
                    color="pink"
                    flat
                    @click="hardRelaod"
                >
                    Refresh
                </v-btn>
            </v-snackbar>
        </v-app>
    </div>
</template>

<script>
    import MainLayout from './layouts/MainLayout'
    import EmptyLayout from './layouts/EmptyLayout'
    import { TokenService } from "./services/token.services";
    import { mapMutations } from 'vuex';
    import appversionServices from './services/appversion.services';

    export default {
        components: {
            MainLayout,
            EmptyLayout
        },

        data() {
            return {
                component: '',
                latestVersion: undefined,
            }
        },

        async created() {
            this.setLayout(this.$route);

            // handle version
            {
                const latest = await appversionServices.getLatestAppVersion();
                const current = appversionServices.getCurrentAppVersion();

                this.latestVersion = latest;

                if (current == undefined) {
                    this.hardRelaod();
                    return;
                }

                if (latest !== current) {
                    this.setRequireReload(true);
                }
            }
        },

        computed: {
            currentComponent() {
                if (!this.component) {
                    if (TokenService.getToken()) {
                        return 'MainLayout'
                    }
                    return 'EmptyLayout'
                }
                return this.component
            },

            requireReload: {
                set(val) {
                    return this.$store.commit('setRequireReload', val);
                },

                get() {
                    return this.$store.state.requireReload;
                }
            }
        },

        watch: {
            '$route'(to) {
                this.setLayout(to)
            }
        },

        methods: {
            setLayout(to) {
                const layout = to.matched.some(record => record.meta.layout === 'empty')
                if (layout) {
                    this.component = 'EmptyLayout'
                } else {
                    this.component = 'MainLayout'
                }
            },

            ...mapMutations([
                "setRequireReload"
            ]),

            hardRelaod() {
                if (this.latestVersion) {
                    appversionServices.setCurrentAppVersion(this.latestVersion);   
                }
                this.requireReload = false;
                location.reload(true);
            }
        }
    }
</script>

<style>
@font-face {
    font-family:'Zawgyi-One';
    src:local('Zawgyi-One'), url('./assets/fonts/zawgyi.woff') format('woff'), url('./assets/fonts/zawgyi.ttf') format('ttf');
}

.zawgyi {
    font-family: "Zawgyi-One"
}
</style>
